module.exports = new __parcel__URL__("GT-Pantheon_animation-fig-12_Ratio.0bbba91a.json").toString();